import styled from 'styled-components'

export const SideDrawerBlackBack = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  cursor: pointer;
`